import { apiGet } from '../config'
import { API_ROUTES } from '../routes'
import { LegalEntities } from '../typing'
import { useQueryHook } from './queryHook'

interface IResponse {
  items: LegalEntities[]
}

export const useGetDictionaryLegalEntities = () => {
  const path = API_ROUTES.DICTIONARY_LEGAL_ENTITIES

  const queryObject = useQueryHook({
    key: [path],
    fetcherFunction: async () => {
      const { data } = await apiGet<object, IResponse>({ path })

      return data
    },
  })

  if (queryObject.isLoading || queryObject.isError) {
    return {
      ...queryObject,
      data: null,
    }
  }

  return {
    ...queryObject,
    data: queryObject.data as IResponse | null,
  }
}
